{
  "notFound": {
    "message": "Ať svítím jak svítím, možná praskla žárovka, ale tato stránka tu není ...",
    "goToDashboard": "Půjdu radši na Dashboard"
  }
}
